module.exports = __webpack_public_path__ + "img/img2.791ce045.jpg";